import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Radio } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";

const links = [
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
];

export function MarketingNav() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-md hairline pt-safe">
      <nav className="mx-auto max-w-6xl px-5 sm:px-8 lg:px-12 h-14 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-display font-semibold tracking-tight text-[15px]">
          <Radio className="h-[18px] w-[18px] text-primary" />
          EchoCRM
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `px-3 py-1.5 text-[13px] rounded-md transition-colors ${
                  isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <ThemeToggle />
          <Button variant="ghost" size="sm" onClick={() => navigate("/login")}>Sign in</Button>
          <Button size="sm" onClick={() => navigate("/signup")}>Get started</Button>
        </div>

        <button
          type="button"
          className="md:hidden relative z-[60] inline-flex items-center justify-center h-11 w-11 -mr-3 text-foreground"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {/* Mobile dropdown menu */}
      <div
        className={`md:hidden overflow-hidden border-t border-border/60 bg-background/95 transition-[max-height,opacity] duration-300 ease-out ${
          open ? "max-h-[24rem] opacity-100" : "max-h-0 opacity-0"
        }`}
        id="mobile-marketing-menu"
      >
        <div className="mx-auto max-w-6xl px-5 sm:px-8 py-4">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-lg text-[15px] font-medium transition-colors ${
                    isActive
                      ? "bg-accent text-foreground"
                      : "text-muted-foreground hover:bg-accent/60 hover:text-foreground"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="mt-4 flex flex-col gap-3 border-t border-border/60 pt-4">
            <div className="flex items-center justify-between px-1">
              <span className="text-xs text-muted-foreground">Theme</span>
              <ThemeToggle />
            </div>
            <Button variant="outline" size="lg" className="w-full" onClick={() => { setOpen(false); navigate("/login"); }}>
              Sign in
            </Button>
            <Button size="lg" className="w-full" onClick={() => { setOpen(false); navigate("/signup"); }}>
              Get started
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}